export default class AutoDismissedError extends Error {
  constructor(public message: string, public timeout: number | boolean = true) {
    super();
  }
}
